import { apiSlice } from '@src/services/api/apiSlice';
import {
    AcceptParams,
    AddUserParams,
    ResendInvitationParams,
} from './addUserApiSliceTypes';
import { User } from '../usersTypes';

const addUserApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addUser: builder.mutation<User, AddUserParams>({
            query: (params) => ({
                url: `/invitations`,
                method: 'POST',
                body: { ...params },
            }),
            invalidatesTags: [{ type: 'users', id: 'LIST' }],
        }),
        resendInvitation: builder.mutation<User, ResendInvitationParams>({
            query: (params) => ({
                url: `/invitations/${params.invitationId}/resend`,
                method: 'POST',
            }),
            invalidatesTags: [{ type: 'users', id: 'LIST' }],
        }),

        accept: builder.mutation<void, AcceptParams>({
            query: (params) => ({
                url: '/invitations/accept',
                method: 'POST',
                body: { ...params },
            }),
        }),
    }),
    overrideExisting: true,
});

export const {
    useAddUserMutation,
    useResendInvitationMutation,
    useAcceptMutation,
} = addUserApiSlice;
